<template>
  <section class="caidf-home-section caidf-third-section">
    <div class="caidf-home-container">
      <div class="caidf-max-width-text">
        <h2 class="caidf-has-text-center caidf-font-open-sans-semi-bold"
          >Besoin d’aide ? Votre conseiller reste à votre écoute pour vous
          accompagner</h2
        >
        <div class="caidf-third-buttons">
          <a
            class="button primary"
            href="https://www.credit-agricole.fr/ca-paris/particulier/campagnes/prendre-rendez-vous-avec-mon-conseiller.html"
            target="_blank"
            >JE PRENDS RENDEZ-VOUS</a
          >
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "ThirdSection",
  data: () => {},
}
</script>
